<template>
  <b-card title="">
    <b-row>
      <!-- {{ groupOptions }} -->

      <b-col cols="6">
        <!-- <p>{{ token }}</p> -->
        <!-- <p>{{ applicationOptions }}</p> -->
        <h3 class="text-primary">Cloud Profile</h3>
      </b-col>
      <b-col cols="6">
        <b-button
          variant="primary"
          class="btn btn-primary float-right"
          @click="back()"
          size="sm"
        >
          Back
        </b-button>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="simpleRules" #default="{ invalid }">
          <b-form @submit.prevent>
            <b-row>
              <!-- first name -->
              <b-col cols="6">
                <b-form-group label="Cloud Name" label-for="v-first-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Cloud Name"
                    rules="required"
                  >
                    <b-form-input
                      id="v-first-name"
                      placeholder="Cloud Name"
                      v-model="cloudName"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Profile Type" label-for="v-first-name">
                  <!-- <validation-provider
                    #default="{ errors }"
                    name="Groups"
                    rules="required"
                  > -->
                  <b-form-select
                    v-model="profileType"
                    :options="profileOptions"
                  >
                  </b-form-select>
                  <!-- {{ profileType }} -->

                  <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <!-- <b-col cols="4">
                <b-form-group label="Firewall Id" label-for="v-first-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Firewall Id"
                    rules="required"
                  >
                    <b-form-input
                      id="v-first-name"
                      placeholder="Firewall Id"
                      v-model="firewallId"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
              <b-col cols="6">
                <b-form-group label="Access Key" label-for="v-first-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Access Key"
                    rules="required"
                  >
                    <b-form-input
                      id="v-first-name"
                      placeholder="Access Key"
                      v-model="accessKey"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Secret Key" label-for="v-first-name">
                    <b-form-input
                      id="v-first-name"
                      placeholder="Secret Key"
                      v-model="secretKey"
                     
                    />
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col cols="12">
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1 mt-1"
                  @click.prevent="addUser()"
                  :disabled="invalid"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BButton,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
// import axiosIns from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import vSelect from "vue-select";
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BButton,
    BCard,
    BFormSelect,
    BFormSelectOption,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      cloudName: "",
      profileType: "",
      profileOptions: [
        { value: "AWS", text: "AWS" },
        { value: "DGO", text: "Digital Ocean" },
        { value: "LightSail", text: "AWS LightSail" },
      ],
      // firewallId: "",
      accessKey: "",
      secretKey: "",
      // accessKey: null,
      // secretKey: null,
      token: "",
      items: [],
    };
  },
  mounted() {
    // this.fetchGroup();
    this.token = this.$store.state.app.token;
  },
  created() {
    // (this.tenantid = this.$store.getters.tenantid),
    //   (this.accesstoken = this.$store.getters.token);
    //   console.log(this.tenantid);
  },
  methods: {
    back() {
      this.$router.push("/eca-cloud");
    },

    addUser() {
      var self = this;
      const body = {
        name: this.cloudName,
        profile_type: this.profileType,
        // firewall_id: this.firewallId,
        access_key: this.accessKey,
        secret_key: this.secretKey,
      };
      const options = {
        method: "POST",
        data: body,
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("JWTtoken")}`,
        //   "content-type": "application/json",
        // },
        url: process.env.VUE_APP_BASEURL + `cloudprofile/cloudprofile/`,
      };
      this.$http(options)
        .then((res) => {
          if (res.data.status === "error") {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "EditIcon",
                variant: "danger",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Created Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.$router.push("/eca-cloud");
          }
        })
        .catch((err) => {
          console.log(err);
          self.$toast({
            component: ToastificationContent,
            props: {
              title: err.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
